"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2620],{

/***/ 89777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24229);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51945);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43701);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71754);
/* harmony import */ var _components_icons_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24162);
/* harmony import */ var _components_ui_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58262);
/* harmony import */ var _features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77910);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7806);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41255);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65820);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83749);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74931);












var SearchPartial = function(param) {
    var t = param.t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), dataSearchKey = ref[0], setDataSearchKey = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref2 = (0,_features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_3__/* .useFetchLiveVideosQuery */ .fN)({
        product_keyword: keyword
    }, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast__WEBPACK_IMPORTED_MODULE_4__/* ["default"].error */ .ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _data = [];
            _data = data.map(function(d) {
                var _d = {};
                var productData = d.live_stream_product.find(function(p) {
                    return p.products.product_code.toLocaleLowerCase() === keyword.toLocaleLowerCase();
                });
                _d = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, productData), {
                    link: d.link,
                    live_stream: {
                        images: d.images,
                        name: d.live_streamer.name,
                        id: d.id + "",
                        title: d.name,
                        duration: d.duration
                    }
                });
                return _d;
            });
            if (keyword) {
                setDataSearchKey(Array.isArray(_data) ? _data : []);
            }
        }
    }), refetchKeyword = ref2.refetch, loadingSearch = ref2.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (keyword !== "") {
            refetchKeyword();
        } else {
            setDataSearchKey([]);
        }
    }, [
        keyword,
        refetchKeyword
    ]);
    var handleChange = function(value) {
        setKeyword(value);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var optimizedFn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((0,_libs_app__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(handleChange, 300), []);
    var clearInput = function() {
        if (inputRef.current) {
            inputRef.current.value = "";
            setKeyword("");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-w-full tw-relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-rounded-5 tw-text-secondary-70 tw-border tw-overflow-hidden tw-border-primary-main tw-py-2 tw-px-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, {
                        className: "tw-w-6 tw-h-6",
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .SearchIcon */ .W, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        ref: inputRef,
                        placeholder: t("layout:label.search-keyword"),
                        className: "tw-w-full tw-outline-none tw-ml-2 tw-placeholder-secondary-70 ",
                        onChange: function(e) {
                            return optimizedFn(e.target.value);
                        }
                    }),
                    keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-text-primary-main tw-cursor-pointer",
                        onClick: clearInput,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_Close__WEBPACK_IMPORTED_MODULE_9__/* .CloseIcon */ .T, {}),
                            className: "tw-w-6 tw-h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__/* .AnimatePresence */ .M, {
                children: keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.div */ .E.div, {
                    className: "tw-absolute tw-drop-shadow tw-px-2 md:tw-px-4 tw-py-2 tw-left-0 tw-z-10 tw-bg-white tw-rounded-5 top-full-8 tw-w-full",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.4
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-overflow-y-scroll tw-max-h-80",
                        children: loadingSearch ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_12__/* .Loading */ .g, {}) : !dataSearchKey.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-py-10 tw-text-center",
                            children: "Kh\xf4ng t\xecm thấy video"
                        }) : dataSearchKey.map(function(data) {
                            var id = data.live_stream.id;
                            var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_1__/* .createHandle */ .UR)(data.live_stream.title), "-").concat(id);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-py-2 tw-border-b",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-w-full md:tw-w-2/3",
                                    onClick: function() {
                                        return clearInput();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                                        url: {
                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_14__/* .PagePath.LiveVideoPage */ ._.LiveVideoPage,
                                            query: {
                                                id: handle,
                                                start: data.played
                                            }
                                        },
                                        className: "tw-w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-py-2 tw-px-4 tw-rounded-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_15__/* .LiveProduct */ .S, {
                                                data: data
                                            })
                                        })
                                    })
                                })
                            }, "live" + id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SearchPartial));


/***/ }),

/***/ 24162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CloseIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C13.1819 3 14.3522 3.23279 15.4442 3.68508C16.5361 4.13738 17.5282 4.80031 18.364 5.63604C19.1997 6.47177 19.8626 7.46392 20.3149 8.55585C20.7672 9.64778 21 10.8181 21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4441 20.3149C14.3522 20.7672 13.1819 21 12 21L12 21Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 9L15 15",
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15 9L9 15",
                stroke: "currentColor",
                strokeLinecap: "round"
            })
        ]
    });
};


/***/ }),

/***/ 64772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ViewIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ViewIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3.5",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                stroke: "currentColor",
                d: "M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
            })
        ]
    });
};


/***/ }),

/***/ 30161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ VideoLoop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7806);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41255);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43701);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81703);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58262);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64772);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55743);
/* harmony import */ var _features_livestream_detail_const__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98346);






var VideoLoop = function(param) {
    var v = param.v, t = param.t, showBell = param.showBell;
    var images = v.images, live_title = v.name, id = v.id, viewer = v.viewer, live_streamer = v.live_streamer, start_datetime = v.start_datetime, duration = v.duration, status = v.status, city = v.city;
    var ref = live_streamer || {}, name = ref.name, avatar = ref.avatar;
    var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_1__/* .createHandle */ .UR)(live_title), "-").concat(id);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
        className: "tw-w-full tw-z-0 tw-block tw-relative tw-border tw-rounded-5 tw-border-gray-31 hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
        url: {
            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PagePath.LiveVideoPage */ ._.LiveVideoPage,
            query: {
                id: handle
            }
        },
        children: [
            showBell && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                alt: "bell",
                src: "/ico_bell.svg",
                className: "!tw-absolute tw--right-3 tw--top-4 tw-w-9 tw-h-9 tw-z-11"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-w-full tw-relative tw-pb-55-percent tw-rounded-t-5 tw-overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                        alt: name,
                        src: (0,_libs_app__WEBPACK_IMPORTED_MODULE_1__/* .getLiveVideoImage */ .eQ)(images),
                        className: "tw-w-full tw-h-full !tw-absolute tw-left-0 tw-top-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1",
                        style: {
                            background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 66.74%, #000000 151.27%)",
                            transform: "rotate(-180deg)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1",
                        style: {
                            background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 71.7%, #000000 113.56%)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-z-11 tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-right-0 tw-text-white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-flex-col tw-h-full tw-justify-between tw-p-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-flex tw-gap-x-1 tw-items-center",
                                children: [
                                    status === _features_livestream_detail_const__WEBPACK_IMPORTED_MODULE_6__/* .LiveStreamStatus.LIVE_NOW */ .zN.LIVE_NOW && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-px-4 tw-bg-red-600 tw-text-white tw-font-xs tw-rounded tw-mr-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-1 tw-block"
                                            }),
                                            "Live"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, {
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .ViewIcon */ .O, {}),
                                        className: "tw-w-5 tw-h-5"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: " tw-text-sm",
                                        children: viewer
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-flex tw-flex-col tw-gap-y-1 tw-px-4 tw-py-4 tw-bg-white tw-rounded-b-5 tw-overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-gap-x-2 tw-items-center tw-text-secondary-70 tw-font-medium",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_9__/* .Avatar */ .q, {
                            src: avatar,
                            className: "tw-w-6 tw-h-6",
                            rounded: "tw-rounded-full"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            dangerouslySetInnerHTML: {
                                __html: name
                            }
                        })
                    ]
                })
            })
        ]
    }, id);
};


/***/ }),

/***/ 71754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LiveProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(10268);
;// CONCATENATED MODULE: ./components/ui/TimeLine/index.tsx



var TimeLive = function(props) {
    var t = (0,esm/* useTranslation */.$G)("layout").t;
    var end = props.end == props.start ? "--:--" : props.end;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "time-line tw-relative line-custom",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ranger tw-relative",
                style: {
                    width: props.width,
                    left: props.left
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-absolute time-line-start tw-font-light tw-text-10 sm:tw-text-sm",
                        children: [
                            t("component.timeline.start"),
                            " ",
                            props.start ? props.start : "--:--"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-absolute time-line-end tw-font-light tw-text-10 sm:tw-text-sm tw-w-max",
                        children: [
                            t("component.timeline.end"),
                            " ",
                            end
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/ui/LiveProduct/index.tsx
/* eslint-disable jsx-a11y/alt-text */ 




var LiveProduct = function(param) {
    var data = param.data;
    var getTimestampByDuration = function(_duration) {
        if (!_duration) return 0;
        var h = _duration.split(":")[0];
        var m = _duration.split(":")[1];
        var s = _duration.split(":")[2];
        return +h * 3600 + +m * 60 + +s;
    };
    var secondsToMinute = function(time) {
        var m = Math.floor(time / 60);
        var s = time - m * 60;
        if (!m && !s) return "--:--";
        return "".concat(m, ":").concat(Math.round(s));
    };
    var _played = data.played || 0;
    var _duration = data.live_stream.duration ? getTimestampByDuration(data.live_stream.duration) : 0;
    var _startP = new Date(data.start_datetime).getTime() / 1000;
    var _startV = new Date(data.start_datetime).getTime() / 1000 - _played;
    var _endV = _duration ? _startV + _duration : new Date().getTime() / 1000;
    var _endP = data.end_datetime ? new Date(data.end_datetime).getTime() / 1000 : _endV;
    var videoProductLength = Math.abs(_endP - _startP);
    var _l = Math.floor(videoProductLength / _duration * 85);
    var _sP = Math.floor(_played / _duration * 85);
    var _eP = Math.floor(videoProductLength + _played);
    if (_played || _sP < 7 || !_sP) _sP = 7;
    if (_l < 15) _l = 15;
    if (_l > 86 || !_l) _l = 86;
    if (_eP > _duration) _eP = 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-grid tw-grid-cols-3 tw-gap-x-4",
                children: [
                    data.live_stream.images && data.live_stream.images[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data.live_stream.images[0].url,
                        width: 130,
                        height: 85,
                        alt: data.live_stream.name,
                        className: "tw-object-cover tw-rounded-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "tw-text-base tw-leading-6 md:tw-leading-7 md:tw-text-xl tw-text-secondary-70 tw-line-clamp-2",
                                children: data.live_stream.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-text-secondary-50 tw-text-base md:tw-text-lg",
                                children: [
                                    data.start_datetime ? (0,dayjs/* humanDate */.rN)(data.start_datetime) : "---",
                                    " | ",
                                    data.live_stream.duration
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-5 tw-h-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeLive, {
                    left: _sP + "%",
                    start: secondsToMinute(_played),
                    width: _l + "%",
                    end: secondsToMinute(_eP)
                })
            })
        ]
    });
};


/***/ }),

/***/ 73786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SelectCustom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_icons_ArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84795);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83749);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65820);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58262);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81703);
/* eslint-disable jsx-a11y/alt-text */ 





var SelectCustom = function(param) {
    var icon = param.icon, options = param.options, value = param.value, placeholder = param.placeholder, handleSelect = param.handleSelect, className = param.className, containerClassName = param.containerClassName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), internalValue = ref1[0], setInternalValue = ref1[1];
    var selectedOption = value !== undefined ? value : internalValue;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("click", handleClick);
    });
    var handleChange = function(option) {
        if (value === undefined) {
            setInternalValue(option);
        }
        handleSelect(option);
        setShow(false);
    };
    var handleClick = function(event) {
        var ref;
        if (wrapperRef.current && !((ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
            setShow(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-flex tw-items-center tw-border tw-relative tw-border-gray-31 tw-rounded-5 ".concat(containerClassName),
        ref: wrapperRef,
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "tw-h-5 tw-w-5 tw-text-secondary-70 tw-cursor-pointer",
                    onClick: function() {
                        return setShow(!show);
                    },
                    children: icon
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(className ? className : "tw-h-10 tw-w-48", " tw-flex tw-items-center tw-text-secondary-70 tw-flex-1 tw-cursor-pointer ").concat(icon ? "tw-px-1" : "tw-px-4"),
                onClick: function() {
                    return setShow(!show);
                },
                children: [
                    (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-flex tw-items-center tw-mr-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                            className: "tw-rounded-full tw-w-5 tw-h-5 tw-overflow-hidden",
                            alt: selectedOption.label,
                            src: selectedOption.image
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-ml-1 tw-flex-1 ".concat((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) ? "tw-text-black" : "tw-text-gray-400"),
                        children: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || placeholder || "Chọn"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                        className: "".concat(icon ? "tw-mr-3" : ""),
                        animate: {
                            rotate: show ? "-180deg" : "0deg"
                        },
                        transition: {
                            duration: 0.4
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-text-secondary-70",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_ArrowDown__WEBPACK_IMPORTED_MODULE_5__/* .ArrowDownIcon */ .v, {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
                children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                    className: "tw-py-2 tw-absolute tw-z-10 top-full-8 tw-border tw-border-gray-31 tw-rounded-5 tw-bg-white tw-w-full tw-left-0",
                    transition: {
                        duration: 0.2
                    },
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "tw-max-h-48 tw-overflow-y-auto tw-w-full tw-py-1",
                        children: options.map(function(o, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: "tw-text-secondary-70 tw-flex tw-items-center  tw-px-4 tw-py-1 tw-cursor-pointer ".concat((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === o.value ? "tw-bg-primary-main !tw-text-white" : ""),
                                onClick: function() {
                                    return handleChange(o);
                                },
                                children: [
                                    o.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "tw-flex tw-items-center tw-mr-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                                            className: "tw-rounded-full tw-w-6 tw-h-6 tw-overflow-hidden",
                                            src: o.image,
                                            alt: o.label
                                        })
                                    }),
                                    o === null || o === void 0 ? void 0 : o.label
                                ]
                            }, "item -" + i);
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 98346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UC": function() { return /* binding */ PinnedProductDefault; },
/* harmony export */   "Ww": function() { return /* binding */ FormChatDefault; },
/* harmony export */   "zN": function() { return /* binding */ LiveStreamStatus; }
/* harmony export */ });


var LiveStreamStatus = {
    LIVE_NOW: "LIVE_NOW",
    UNPUBLISHED: "UNPUBLISHED",
    SCHEDULED_LIVE: "SCHEDULED_LIVE",
    SCHEDULED_CANCELED: "SCHEDULED_CANCELED",
    SCHEDULED_UNPUBLISHED: "SCHEDULED_UNPUBLISHED",
    VOD: "VOD",
    LIVE: "LIVE"
};
/**
 * Default !value
 */ var FormChatDefault = {
    comment: ""
};
var PinnedProductDefault = null;


/***/ }),

/***/ 83134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ LiveVideosDefault; }
/* harmony export */ });
var LiveVideosDefault = {
    edges: [],
    count: 0
};


/***/ })

}]);